import React from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Checkbox from 'material-ui/Checkbox';

import { alphaSort } from '../../utils/helpers';

const MultiSelectFilterItem = props => {
  function selectChanged(event, index, values) {
    if (values.indexOf('ANY') < 0) {
      props.onChange({
        name: props.filterName,
        values
      });
    } else {
      //clear the selection
      props.onChange({
        name: props.filterName,
        values: []
      });
    }
  }

  function checkChanged(e) {
    props.onChange({
      name: props.filterName,
      values: [!e]
    });
  }

  function getMenuItems(options) {
    return options.sort(alphaSort('name')).map(option => {
      return (
        <MenuItem
          style={styles.menuItem}
          key={option.code}
          insetChildren={true}
          checked={props.values && props.values.indexOf(option.code) > -1}
          value={option.code}
          primaryText={option.name}
        />
      );
    });
  }

  function selectionRenderer(values) {
    if (values.length === 0 || values.indexOf('ANY') > -1) {
      return 'Any';
    } else {
      switch (values.length) {
        case 0:
          return '';
        case 1:
          return props.options.filter(option => {
            return option.code === values[0];
          })[0].name;
        default:
          return `${values.length} Selected`;
      }
    }
  }

  if (props.options.length > 1) {
    return (
      <SelectField
        multiple={true}
        fullWidth={true}
        value={props.values}
        onChange={selectChanged}
        selectionRenderer={selectionRenderer}
      >
        <MenuItem
          key="any"
          insetChildren={true}
          checked={props.values.length === 0}
          value="ANY"
          primaryText="Any"
        />
        {getMenuItems(props.options)}
      </SelectField>
    );
  } else {
    return (
      <Checkbox
        label={props.label}
        checked={props.values.indexOf(props.options[0].code)}
        onCheck={checkChanged}
      />
    );
  }
};

const styles = {
  menuItem: {
    textTransform: 'capitalize'
  }
};

export default MultiSelectFilterItem;



// WEBPACK FOOTER //
// ./src/components/filter/MultiSelectFilterItem.js